module.exports = __webpack_public_path__ + "static/media/bg-404.0eb9e5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-404.png
// module id = 687
// module chunks = 0